import { useQuery } from "@tanstack/react-query";

function isManualLibraryId(value: string): boolean {
  // If libraryId is not provided, we assume it is a manual libraryId
  if (value == null) return true;
  const trimmed = value.trim();
  if (trimmed === "" || trimmed.toLowerCase().startsWith("manual-")) {
    return true;
  }
  return false;
}

export function useFullPaperLibraryLink(
  libraryId: string | undefined,
  doi: string | undefined,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ["full-paper-library-link", libraryId, doi],
    queryFn: async () => {
      const response = await fetch(
        `/api/libraries/${libraryId}/full-paper-library-link?doi=${encodeURIComponent(
          doi!
        )}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch full paper library link");
      }
      const data = await response.json();
      return data.full_paper_library_link;
    },
    enabled:
      enabled && Boolean(libraryId && !isManualLibraryId(libraryId) && doi),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1, // Only retry once to avoid excessive API calls
  });
}
